import { useState } from "react";

import { useSession } from "next-auth/react";
import { useRouter } from "next/router";

import PropTypes from "prop-types";

import { useGetProductQuestions } from "@/api/client/product";
import { AskQuestionModal } from "@/components/actions";
import HorizontalLine from "@/components/data-display/horizontalLine";
import ProductQuestion from "@/components/data-display/product-question";
import Pagination from "@/components/navigation/pagination";

function ProductQuestionSection({ data, productName }) {
  const { data: session } = useSession();
  const [page, setPage] = useState(1);
  const [questions, setQuestions] = useState(data);
  const [isPaginating, setPaginating] = useState(false);

  const {
    query: { product_slug },
  } = useRouter();

  const {
    meta,
    total_question_count,
    questions: questionList,
  } = questions || {};

  useGetProductQuestions({
    enabled: isPaginating,
    query: { product_slug, page },
    onSuccess: (data) => {
      setQuestions((prevState) => ({ ...prevState, ...data }));
    },
  });

  const handlePagination = (page) => {
    setPage(page + 1);
    if (!isPaginating) setPaginating(true);
  };

  return (
    <section>
      <div className="mb-[2.313rem] flex flex-col space-y-[1.5rem] lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
        <div className="space-y-[1.125rem]">
          <h3 className="text-[1.25rem] font-semibold text-grayDisplay-900">
            Questions {total_question_count > 0 && `(${total_question_count})`}
          </h3>
          <span className="block text-[0.938rem] text-grayDisplay-850">
            Have question about this product? Get specific details about this
            product from expert.
          </span>
        </div>

        {session?.user?.token && <AskQuestionModal productName={productName} />}
      </div>

      {questionList?.length > 0 ? (
        <>
          <HorizontalLine className="mb-[2.313rem] lg:hidden" />

          <div className="space-y-[1.688rem]">
            {questionList.map((el, i) => (
              <div key={i}>
                <ProductQuestion questionData={el} />
                <HorizontalLine />
              </div>
            ))}
          </div>

          {meta?.total > meta?.per_page && (
            <div className="flex justify-center lg:justify-start">
              <Pagination
                getPaginateData={handlePagination}
                initialPage={meta.current_page - 1}
                totalPage={Math.ceil(meta.total / meta.per_page)}
              />
            </div>
          )}
        </>
      ) : (
        <p className="mb-[2rem] text-center text-2xl font-bold">
          No Question Available. Ask your first question.
        </p>
      )}
    </section>
  );
}

ProductQuestionSection.propTypes = {
  data: PropTypes.shape({
    meta: PropTypes.object,
    questions: PropTypes.array,
    total_question_count: PropTypes.number,
  }),
};

export default ProductQuestionSection;
